import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentCard: 1,
};

export const cardSlices = createSlice({
  name: "currentCard",
  initialState,
  reducers: {
    nextCard: (state, actions) => {
      state.currentCard = 2;
    },
    preCard: (state, action) => {
      state.currentCard = 1;
    },
    resetCard: (state, action) => {
      state.currentCard = 1;
    },
  },
});

export const { nextCard, preCard, resetCard } = cardSlices.actions;

export default cardSlices.reducer;
